export default "__VITE_ASSET__CuFY89E___"